import React from 'react';

function FlexLayout(props) {
  var style = Object.assign({}, props.style, {
    flexDirection: props.direction || 'row',
    flexWrap: props.wrap || 'nowrap',
    position: 'relative',
    display: 'flex',
    height: '100%',
    width: '100%'
  });
  return React.createElement("div", {
    className: props.className,
    style: style
  }, props.children);
}

function FlexChild(props) {
  var style = Object.assign({
    position: 'relative'
  }, props.style, {
    flexGrow: props.grow || 0,
    flexShrink: props.shrink || 0,
    width: props.width,
    height: props.height
  });
  return React.createElement("div", {
    className: props.className,
    style: style
  }, props.children);
}

export { FlexLayout, FlexChild };